import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";

export default function PlaybackSpeedBtns({
  playbackSpeed,
  changePlaybackSpeed,
  answer,
  sound,
  audioFinished = false, // Add this new prop
}) {
  const OneX = 1;
  const OneX2 = 1.2;
  const OneX5 = 1.5;
  const speedOptions = [OneX, OneX2, OneX5];

  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(OneX);

  const onSelect = (item) => {
    setSelected(item);
    changePlaybackSpeed(item);
    setShow(false);
  };

  // Disable if answer exists, sound is false, OR audio has finished
  const disabled = answer || sound === false || audioFinished;

  return (
    <div style={styles.container}>
     <label style={styles.label}>Speed</label>
    <Dropdown show={show} onToggle={() => !disabled && setShow(!show)} id="playbackbtn">
      <Dropdown.Toggle
        as="span"
        style={{
          ...styles.toggle,
          ...(show ? styles.toggleOpen : {}),
          ...(disabled ? styles.disabled : {}),
        }}
        onClick={() => !disabled && setShow(!show)}
      >
        <div>{selected}x</div>
        <span style={styles.arrow}></span>
        {/* {show ? "▲" : "▼"} */}
      </Dropdown.Toggle>

      <Dropdown.Menu style={styles.menu}>
        {speedOptions.map(
          (item, i) =>
            item !== selected && (
              <Dropdown.Item
                key={i}
                style={styles.item}
                onClick={() => onSelect(item)}
              >
                {item}x
              </Dropdown.Item>
            )
          )}
      </Dropdown.Menu>
    </Dropdown>
          </div>
  );
}

const styles = {
  container: {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  alignItems: "start"
},

label: {
  fontSize: "12px",
  fontWeight: "500",
  color: "#333",
},

  toggle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "6px",
    padding: "9px 12px",
    border: "1px solid #000",
    borderRadius: "25px",
    backgroundColor: "#fff",
    cursor: "pointer",
    userSelect: "none",
    fontSize: "14px",
  },

  toggleOpen: {
    borderColor: "#000",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
    backgroundColor: 'white',
  },

  arrow: {
    fontSize: "10px",
    marginLeft: "6px",
  },

  menu: {
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
    backgroundColor: 'white',
    background: 'white',
    // inset: '0px auto auto 22px',
    minWidth: "135px",
    transform: 'translate(-15px, 50px)',
    margin: '0px'
  },

  item: {
    padding: "8px 14px",
    fontSize: "14px",
    cursor: "pointer",
  },

  disabled: {
    opacity: 0.6,
    cursor: "not-allowed",
    pointerEvents: "none",
  },
};